module.exports = __webpack_public_path__ + "img/166-morocco.a3dd98bd.svg";